// Mirrors aws-lambda/handlers/resorts-list.mjs. Keep both in sync (same tradeoff Diver's Horizon makes
// for site names). Coordinates are approximate resort base-area locations.
//
// `passes`: which of PASS_TYPES (src/constants/passTypes.js) cover this resort — verified via web search
// 2026-09 (Epic Pass site, Mountain Collective's own Sugar Bowl page, Ikon Pass roster). Boreal/Homewood/
// Mt. Rose carry no major multi-resort pass here on purpose — see aws-lambda/shared/resorts.mjs for the
// full sourcing note. Passes change year to year; re-verify before trusting this for an unchecked season.
export const RESORTS = [
  { resortId: "palisades-tahoe", name: "Palisades Tahoe", route: "i80", lat: 39.1968, lng: -120.2356, passes: ["ikon"] },
  { resortId: "northstar", name: "Northstar", route: "i80", lat: 39.2746, lng: -120.1211, passes: ["epic"] },
  { resortId: "sugar-bowl", name: "Sugar Bowl", route: "i80", lat: 39.3062, lng: -120.3336, passes: ["mountain_collective"] },
  { resortId: "boreal", name: "Boreal", route: "i80", lat: 39.3372, lng: -120.3489, passes: [] },
  { resortId: "homewood", name: "Homewood", route: "i80", lat: 39.0865, lng: -120.1636, passes: [] },
  { resortId: "heavenly", name: "Heavenly", route: "us50", lat: 38.9353, lng: -119.9400, passes: ["epic"] },
  { resortId: "kirkwood", name: "Kirkwood", route: "us50", lat: 38.6850, lng: -120.0654, passes: ["epic"] },
  { resortId: "mt-rose", name: "Mt. Rose", route: "us50", lat: 39.3289, lng: -119.8864, passes: [] },
];

export const RESORTS_BY_ID = Object.fromEntries(RESORTS.map((r) => [r.resortId, r]));
